var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20589 14C7.03216 13.9977 6.86559 13.9334 6.73887 13.8197L2.15065 9.42884C2.04613 9.30697 1.99272 9.15224 2.0008 8.99477C2.00888 8.83729 2.07788 8.68833 2.19438 8.57684C2.31088 8.46535 2.46654 8.39932 2.6311 8.39159C2.79565 8.38385 2.95733 8.43497 3.08468 8.535L7.20589 12.4867L15.9153 4.14417C16.0427 4.04415 16.2043 3.99303 16.3689 4.00077C16.5335 4.0085 16.6891 4.07453 16.8056 4.18602C16.9221 4.2975 16.9911 4.44647 16.9992 4.60395C17.0073 4.76142 16.9539 4.91614 16.8493 5.03802L7.6729 13.8197C7.54619 13.9334 7.37962 13.9977 7.20589 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cccf94a35dea2207931198541f3b73c1.svg";
export { ForwardRef as ReactComponent };